import useFormatMoney from '../../hooks/useFormatMoney';

interface MoneyFormatProps {
  amount: number;
  currency?: {
    currency: string;
    convertPrice: (price: number) => number;
  };
  shouldAddNegativePrefixSign?: boolean;
}

/**
 * Renders the formatted money amount, optionally accounting for negative values.
 *
 * @param {number} amount - The monetary amount to display.
 * @param {Currency | undefined} currency - The currency to use for formatting (optional).
 * @param {boolean | undefined} isNegative - Indicates whether the amount is negative (true) or not (false).
 *
 * @returns {React.JSX.Element} The formatted money amount as a React element.
 */
export default ({
  amount,
  currency,
  shouldAddNegativePrefixSign,
}: MoneyFormatProps): React.JSX.Element => {
  const formattedMoney: string = useFormatMoney(amount, currency);
  return (
    <>
      {shouldAddNegativePrefixSign ? '-' : ''} {formattedMoney}
    </>
  );
};
